import React, { useEffect, useState, useRef, lazy, memo } from 'react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { EditorialMethodBox } from '../components/EditorialMethodBox';
import { ImageCarousel } from '../components/ImageCarousel';
import { PremiumOfferSection } from '../components/PremiumOfferSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { CheckCircle2, AlertCircle, Gift, PlayCircle, Star, Clock, ShieldCheck, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
export function LandingPage() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  const scrollCarousel = (direction: 'left' | 'right') => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  // scrollToOffer removed in favor of CartDrawer
  return <div className="min-h-screen bg-[#FFFBEB] text-gray-900 font-inter selection:bg-orange-200" data-id="element-279">
      {/* ANNOUNCEMENT BAR */}
      <div className="sticky top-0 z-50 bg-[#FF8C00] h-[44px] flex items-center overflow-hidden whitespace-nowrap" data-id="element-280">
        <div className="animate-marquee flex items-center gap-0" data-id="element-281">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-282">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
        <div className="animate-marquee2 flex items-center gap-0 absolute" data-id="element-283">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-284">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
      </div>

      <PurchaseNotifications data-id="element-285" />

      {/* PROBLEM & AGITATION SECTION */}
      <section className="py-16 px-4 bg-white/80 pt-[0px] pb-[0px]" data-id="element-286">
        <div className="max-w-2xl mx-auto" data-id="element-287">
          <h2 className="md:text-3xl text-center mb-8 text-gray-900 pt-[17px] pb-[17px] text-[20px] font-[500] font-[Poppins,_sans-serif]" data-id="element-288">
            Vuelve a comer pan SIN GLUTEN, sin picos de azúcar y sin inflamación
            en menos de 7 días… con recetas que funcionan desde el primer
            intento
          </h2>

          <img src="https://cdn.magicpatterns.com/uploads/ncxuiwQN7ZkZfoqhaAqs2z/Tarta_sin_gluten_de_frutas.png" alt="Recetas de Pan Sin Gluten - Paso a Paso" className="w-full rounded-xl mb-8" data-id="element-289" />

          {/* Identification Card */}
          <div className="bg-[#FBF8F1] rounded-[14px] shadow-[0_2px_16px_rgba(0,0,0,0.06)] p-7 md:p-10 mb-10 border border-[#F0EBE0]" data-id="element-290">
            <h3 className="md:text-[22px] font-bold text-gray-900 text-center mb-1 font-[Roboto,_sans-serif] tracking-tight text-[24px]" data-id="element-291">
              ESTA GUÍA ES PARA TI SI…
            </h3>
            <p className="text-center mb-6" data-id="element-292">
              <span className="text-[#C8A84E] font-semibold md:text-[19px] font-[Roboto,_sans-serif] text-[16px]" data-id="element-293">
                👉 Te identificas con esto y ya estás cansado de vivir así:
              </span>
            </p>

            <div className="space-y-5 max-w-lg mx-auto" data-id="element-294">
              {['Dejaste el pan porque te sube el azúcar… pero no querías hacerlo.', 'Has gastado dinero en productos "saludables" que terminan en la basura.', 'Intentaste hacer pan en casa… y salió incomible.', 'Te sientes limitado cada vez que ves a otros comer lo que tú no puedes.', 'Estás cansado de elegir entre tu salud… o disfrutar la comida.'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-295">
                  <CheckCircle2 className="w-5 h-5 text-[#7BAE7F] flex-shrink-0 mt-0.5" data-id="element-296" />
                  <p className="text-gray-800 md:text-[16px] text-[16px]" data-id="element-297">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Image Carousel - reinforces "Esta guía es para ti" */}
      <div className="pt-6 md:pt-10 bg-white/80" data-id="element-298">
        <h2 className="text-2xl md:text-4xl font-black text-gray-900 uppercase tracking-tight text-center px-4 mb-6 md:mb-8" data-id="element-299">
          Estas son algunas de las recetas que{' '}
          <span className="text-[#D9A441]" data-id="element-300">te esperan</span>
        </h2>
        <ImageCarousel data-id="element-301" />
      </div>

      {/* HERO SECTION */}
      <section className="py-16 md:py-24 px-4 bg-[#FFFBEB] pt-[0px] pb-[0px]" data-id="element-302">
        <div className="max-w-2xl mx-auto pt-[10px] pb-[10px]" data-id="element-303">
          <div className="flex justify-center mb-10 pt-[15px] pb-[15px]" data-id="element-304">
            <WhatsAppButton text="Sí, quiero mi pack ahora" data-id="element-305" />
          </div>

          <div className="rounded-3xl shadow-2xl shadow-black/5 border border-[#F0EBE0] bg-white p-2 md:p-3" data-id="element-306">
            <img src="https://cdn.magicpatterns.com/uploads/tmEmy4s1BuFW3wzaKnt6Rc/Variedad_de_panes_recien_horneados.png" alt="Variedad de panes recién horneados" className="w-full h-auto rounded-2xl object-cover" loading="lazy" data-id="element-307" />
          </div>
        </div>
      </section>

      <FrustrationMethodSection data-id="element-308" />

      {/* SOLUTION & OFFER SECTION */}
      <section id="offer-section" className="py-16 px-4 bg-amber-50/80 space-y-[10px] pt-[0px] pb-[0px]" data-id="element-309">
        <div className="max-w-2xl mx-auto pt-[15px] pb-[15px]" data-id="element-310">
          <div className="text-center mb-10" data-id="element-311"></div>

          <PremiumOfferSection data-id="element-312" />
        </div>
      </section>

      {/* Trust Badges */}
      <div className="py-6 px-4 bg-[#FFFBEB] pt-[0px] pb-[0px]" data-id="element-313">
        <div className="max-w-md mx-auto" data-id="element-314"></div>
      </div>

      {/* DEMO SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center pt-[15px] pb-[15px]" data-id="element-315">
        <div className="max-w-2xl mx-auto bg-[ffff]" data-id="element-316">
          <h2 className="font-black mb-8 text-[20px] pt-[15px] pb-[15px] font-[Merriweather,_serif]" data-id="element-317">
            👉 Solo por hoy: llévate GRATIS el "MEGA PACK Anti-Gluten" al
            completar tu acceso
          </h2>

          {/* Carousel */}
          <div className="relative overflow-hidden mb-8" data-id="element-318">
            <div className="flex transition-transform duration-700 ease-in-out" style={{
            transform: `translateX(-${activeSlide * 100}%)`
          }} data-id="element-319">
              {bonusImages.map((item, index) => <div key={index} className="flex-shrink-0 w-full" data-id="element-320">
                  <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-700 mb-4 relative" data-id="element-321">
                    <img src={item.src} alt={item.title} className="w-full aspect-square object-cover" loading="lazy" data-id="element-322" />
                    <span className="absolute bottom-3 right-3 bg-red-600 text-white font-black text-sm px-3 py-1.5 rounded-lg shadow-lg uppercase tracking-wide" data-id="element-323">
                      FREE
                    </span>
                  </div>
                  <p className="text-white font-bold text-lg" data-id="element-324">{item.title}</p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-325">{item.subtitle}</p>
                </div>)}
            </div>

            {/* Dot indicators */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-326">
              {bonusImages.map((_, index) => <button key={index} onClick={() => setActiveSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeSlide ? 'bg-amber-500 scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-327" />)}
            </div>
          </div>

          <p className="text-gray-400 italic text-lg" data-id="element-328">
            Esto es más fácil de lo que imaginas 👇
          </p>
        </div>
      </section>

      <EditorialMethodBox data-id="element-329" />

      {/* BONUSES SECTION - HIGH CONVERSION */}
      <section className="py-16 px-4 bg-gradient-to-b from-amber-50 to-orange-50 pt-[0px] pb-[0px]" data-id="element-330">
        <div className="max-w-3xl mx-auto" data-id="element-331">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-332">
            <h2 className="md:text-4xl font-black mb-4 pt-[10px] pb-[10px] font-[Merriweather,_serif] text-[20px] text-[#101827]" data-id="element-333">
              10.000+ familias ya están logrando resultados reales con estas
              recetas
            </h2>
          </div>

          {/* Auto-scrolling testimonial carousel */}
          <div className="overflow-hidden mb-10 rounded-2xl" data-id="element-334">
            <div className="flex w-max" style={{
            animation: 'carousel-scroll 25s linear infinite'
          }} data-id="element-335">
              {['https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp', 'https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp', 'https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp'].map((src, index) => <div key={index} className="flex-shrink-0 px-2" data-id="element-336">
                  <img src={src} alt="Testimonio de cliente feliz" className="w-72 h-[500px] object-cover rounded-xl shadow-lg" loading="lazy" data-id="element-337" />
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS / OPINIONES VERIFICADAS */}
      <TestimonialSection data-id="element-338" />

      {/* VALUE STACK & PRICE ANCHORING */}
      <ValueStackSection data-id="element-339" />

      {/* OBJECTIONS & FAQ */}
      <section className="py-16 px-4 bg-white/80 pt-[5px] pb-[5px]" data-id="element-340">
        <div className="max-w-2xl mx-auto" data-id="element-341">
          <h2 className="font-black text-center mb-10 font-[Merriweather,_serif] text-[20px]" data-id="element-342">
            ¿Tienes dudas? Te respondo directo:
          </h2>

          <div className="grid gap-4" data-id="element-343">
            <div className="border-2 border-gray-100 rounded-xl p-5 pt-[20px] pb-[20px]" data-id="element-344">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-345">
                <span className="text-green-500" data-id="element-346">👉</span> ¿Necesito experiencia
                cocinando?
              </h4>
              <p className="text-gray-600" data-id="element-347">
                No. Todo está explicado paso a paso. Funciona desde el primer
                intento.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-348">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-349">
                <span className="text-green-500" data-id="element-350">👉</span> ¿Los ingredientes son
                caros o difíciles de conseguir?
              </h4>
              <p className="text-gray-600" data-id="element-351">
                Para nada. Usamos ingredientes económicos y fáciles de conseguir
                en cualquier mercado.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-352">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-353">
                <span className="text-green-500" data-id="element-354">👉</span> ¿Funciona para
                diabéticos?
              </h4>
              <p className="text-gray-600" data-id="element-355">
                ¡Sí! Las recetas están pensadas para no generar picos de
                insulina.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-356">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-357">
                <span className="text-green-500" data-id="element-358">👉</span> ¿Cómo lo recibo?
              </h4>
              <p className="text-gray-600" data-id="element-359">
                El envío es inmediato por correo. Recibes todo al instante
                después de tu compra.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE BADGE */}
      <section className="py-12 px-4 bg-[#FFFBEB]" data-id="element-360">
        <div className="max-w-lg mx-auto" data-id="element-361">
          <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-8 md:p-10 text-center" data-id="element-362">
            {/* Badge Circle */}
            <div className="mx-auto mb-6 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-363">
              <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-364">
                30
              </span>
              <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-365">
                Días
              </span>
              <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-366">
                Garantía
              </span>
            </div>

            {/* Title */}
            <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-4 font-[Merriweather,_serif]" data-id="element-367">
              TU COMPRA ESTÁ{' '}
              <span className="text-[#D9A441]" data-id="element-368">100% PROTEGIDA</span>
            </h3>

            {/* Description */}
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-369">
              No quiero tu dinero si este manual no transforma tu cocina. Por
              eso te doy mi{' '}
              <span className="font-bold text-gray-900" data-id="element-370">
                Garantía Blindada de 30 Días
              </span>
              .
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5" data-id="element-371">
              Si sentís que no es para vos, nos enviás un correo y te devolvemos
              el{' '}
              <span className="font-bold text-gray-900" data-id="element-372">
                100% de tu inversión
              </span>
              . Sin preguntas, sin vueltas.
            </p>

            {/* Closing line */}
            <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-373">
              — El riesgo es todo nuestro.
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY & FINAL CLOSE */}

      {/* Bottom spacer for floating CTA */}
      <div className="h-20" data-id="element-374" />
    </div>;
}